module.exports = __webpack_public_path__ + "static/img/news-title.23811cec.png";